export default "<h2 class=modal-header>Reset Your Password</h2> <div class=container> <div><button type=button ng-click=vm.email()>Send an Email</button></div> <div><button type=button ng-click=vm.question()>Answer Security Question</button></div> <div><button type=button ng-click=vm.close()>Cancel</button></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/signIn/selectResetOption.tpl.html
// module id = 867
// module chunks = 0